import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Button, Link, Icon } from 'next/components/ui';

export default function AnalyticsHeaderActions({ id, onClickOpenInBuilder }) {
  return (
    <ButtonGroup>
      <Button kind="secondary" forwardedAs={Link} to={`/pins/${id}/settings`}>
        Settings
      </Button>
      <Button onClick={onClickOpenInBuilder}>
        <Icon icon="edit" />
        Open in Builder
      </Button>
    </ButtonGroup>
  );
}

AnalyticsHeaderActions.propTypes = {
  id: PropTypes.string,
  onClickOpenInBuilder: PropTypes.func,
};
